import { useTranslation } from 'react-i18next';
import { Crown, Target, Users, Settings } from 'lucide-react';

export function PersonaSection() {
  const { t } = useTranslation();

  const personas = [
    { icon: Crown, title: t('landing.personas.ceoTitle'), desc: t('landing.personas.ceoDesc') },
    { icon: Target, title: t('landing.personas.headTitle'), desc: t('landing.personas.headDesc') },
    { icon: Users, title: t('landing.personas.managerTitle'), desc: t('landing.personas.managerDesc') },
    { icon: Settings, title: t('landing.personas.revopsTitle'), desc: t('landing.personas.revopsDesc') },
  ];

  return (
    <section className="py-20" style={{ backgroundColor: '#F4F5FF' }}>
      <div className="container">
        <h2 className="mb-12 text-center text-3xl font-bold tracking-tight text-[#1A1F3C] md:text-4xl">
          {t('landing.personas.headline')}
        </h2>

        <div className="mx-auto max-w-4xl grid gap-6 sm:grid-cols-2">
          {personas.map((p, i) => (
            <div key={i} className="rounded-xl border border-[#1A1F3C]/8 bg-white p-6 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#4F6CFF]/10">
                  <p.icon className="h-6 w-6 text-[#4F6CFF]" />
                </div>
                <div>
                  <h3 className="font-semibold text-[#1A1F3C] mb-1">{p.title}</h3>
                  <p className="text-sm text-[#1A1F3C]/60 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
